import { useDispatch, useSelector } from 'react-redux';
import Maps from './components/inquery/Maps';
import { DataContainer } from './components/DataContainer';
import { useEffect, useState } from 'react';
import { default as FNS, logIn } from './api';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getBrand } from './brands';



const STATE_EXPIRED = 100;
const STATE_LOADING = 0;
const STATE_IDLE = 1;
const STATE_SUBMITTING = 2;
const STATE_SUCCESS = 3;
const STATE_ALREADY_SUBMITTED = 4;

function AcceptResponse() {
    const [ state, setState ] = useState(STATE_IDLE);
    const [ fullname, setFullname ] = useState("");
    const [ email, setEmail ] = useState("");
    const [ phone, setPhone ] = useState("");
    const [searchParams] = useSearchParams();
    const [ alreadyRejectedReason, setAlreadyRejectedReason ] = useState(null);
    // Which company's site to send the client back to ("Avalehele") — comes with the query
    const [ brand, setBrand ] = useState(getBrand(null));

    const id = searchParams.get('id');
    const activation_key = searchParams.get('activation_key');

    console.log(id, activation_key);

    useEffect(async () => {
        try {
            const response = await FNS.getQueryConfirmInfo(id, activation_key);
            const { alreadyAnswered, query_fullname, query_email, query_phone, answer, query_brand } = response;
            setBrand(getBrand(query_brand));

            if(alreadyAnswered) {
                setState(STATE_ALREADY_SUBMITTED);
                setAlreadyRejectedReason(answer || null);
                return;
            }
            setFullname(query_fullname);
            setEmail(query_email);
            setPhone(query_phone);
            setState(STATE_IDLE);

        } catch(e) {
            if(e?.cause?.cause == "Vale aktiveerimis võti") {
                setState(STATE_EXPIRED);
                return;
            }
        }
    }, []);

    async function submit() {
        const { alreadyAnswered } = await FNS.emailAcceptResponse(id, activation_key, fullname, email, phone);
        setState(alreadyAnswered ? STATE_ALREADY_SUBMITTED : STATE_SUCCESS);
        if(!alreadyAnswered) toast.success("Tellimus aktsepteeritud");
    };

    switch(state) {
        case STATE_IDLE: return (
            <div className="width100 g16 p32 column center-main center-cross" style={{ height: '100vh' }}>
                <div className="column g16" style={{ maxWidth: 480 }}>

                    <h1>Viimane samm.</h1>
                    <p>Soovi korral võite lisada reisile grupijuhi andmed. Kui tellija on ühtlasi ka grupijuht siis jätke lahtrid selliselt nagu nad on ja vajutage "Kinnita".</p>



                    <div className="column g8 grow">
                        <b>Täisnimi</b>
                        <input type='text' value={fullname} onChange={e => setFullname(e.target.value)} />
                    </div>

                    <div className="column g8 grow">
                        <b>E-mail</b>
                        <input type='text' value={email} onChange={e => setEmail(e.target.value)} />
                    </div>

                    <div className="column g8 grow">
                        <b>Telefon</b>
                        <input type='text' value={phone} onChange={e => setPhone(e.target.value)} />
                    </div>

                    <button onClick={submit} style={{ marginTop: 32, backgroundColor: '#88f', borderRadius: 4, padding: 8, paddingInline: 16, color: '#fff', fontSize: 21 }}>Kinnita</button>

                </div>
            </div>
        );
        case STATE_LOADING:
        case STATE_SUBMITTING: return (

            <DataContainer forceLoading={true} >
                <div style={{ width: '100%', minHeight: '100vh' }}></div>
            </DataContainer>

        );
        case STATE_SUCCESS: return (

            <div className="width100 g32 p32 column center-main center-cross" style={{ height: '100vh' }}>
                <h1 className="title">Täname!</h1>
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_604_139)"><circle cx="32" cy="32" r="32" fill="#65D190"/><path d="M9.37259 32.0001L15.0294 26.3432L26.3432 37.6569L48.9706 15.0295L54.6274 20.6864L26.3432 48.9707L9.37259 32.0001Z" fill="white"/></g><defs><clipPath id="clip0_604_139"><rect width="64" height="64" fill="white"/></clipPath></defs></svg>
                <p style={{ textAlign: 'center' }}>Tellimus on vastuvõetud. Saadame Teile tellimuse kinnituse, see võib võtta pisut aega.</p>
                <a href={brand.siteUrl} style={{ backgroundColor: '#88f', borderRadius: 4, padding: 8, paddingInline: 16, color: '#fff' }}>Avalehele</a>
            </div>

        );
        case STATE_ALREADY_SUBMITTED: return alreadyRejectedReason == "accepted" ? (
            <div className="width100 g32 p32 column center-main center-cross" style={{ height: '100vh' }}>
                <h1 className="title">Täname!</h1>
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_604_139)"><circle cx="32" cy="32" r="32" fill="#65D190"/><path d="M9.37259 32.0001L15.0294 26.3432L26.3432 37.6569L48.9706 15.0295L54.6274 20.6864L26.3432 48.9707L9.37259 32.0001Z" fill="white"/></g><defs><clipPath id="clip0_604_139"><rect width="64" height="64" fill="white"/></clipPath></defs></svg>
                <p style={{ textAlign: 'center' }}>Teie tellimus on juba saadetud. Tellimuse kinnitamine võib võtta pisut aega.</p>
                <a href={brand.siteUrl} style={{ backgroundColor: '#88f', borderRadius: 4, padding: 8, paddingInline: 16, color: '#fff' }}>Avalehele</a>
            </div>
        ) : (
            <div className="width100 g32 p32 column center-main center-cross" style={{ height: '100vh' }}>
                <h1 className="title">Reisist keeldumine</h1>
                <svg width="64" height="64" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none"><g clip-path="url(#clip0_1021_179)"><circle cx="32" cy="32" r="32" fill="#D16565"/><path fill-rule="evenodd" clip-rule="evenodd" d="M48.9706 20.6864L43.3137 15.0295L32 26.3432L20.6863 15.0295L15.0294 20.6864L26.3431 32.0001L15.0294 43.3138L20.6863 48.9707L32 37.6569L43.3137 48.9707L48.9706 43.3138L37.6569 32.0001L48.9706 20.6864Z" fill="white"/></g><defs><clipPath id="clip0_1021_179"><rect width="64" height="64" fill="white"/></clipPath></defs></svg>
                <p style={{ textAlign: 'center' }}>Olete juba reisi tühistanud. Kui soovite reisi ikkagi kinnitada, siis võtke meiega ühendust.</p>
                <p>{brand.contactEmail}</p>
                <a href={brand.siteUrl} style={{ backgroundColor: '#aaf', borderRadius: 4, padding: 8, color: '#fff' }}>Avalehele</a>
            </div>
        );
        case STATE_EXPIRED: return (

            <div className="width100 g32 p32 column center-main center-cross" style={{ height: '100vh' }}>
                <h1 className="title">Link aegunud!</h1>
                <svg width="64" height="64" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 30 30"><path fill="#f78f8f" d="M15,28.5C7.556,28.5,1.5,22.444,1.5,15S7.556,1.5,15,1.5S28.5,7.556,28.5,15S22.444,28.5,15,28.5z"></path><path fill="#c74343" d="M15,2c7.168,0,13,5.832,13,13s-5.832,13-13,13S2,22.168,2,15S7.832,2,15,2 M15,1 C7.268,1,1,7.268,1,15s6.268,14,14,14s14-6.268,14-14S22.732,1,15,1L15,1z"></path><path fill="#fff" d="M14 8H16V22H14z" transform="rotate(134.999 15 15)"></path><path fill="#fff" d="M14 8H16V22H14z" transform="rotate(-134.999 15 15)"></path></svg>
                <p style={{ textAlign: 'center' }}>See link on aegunud, sest teile on saadetud uus Hinnapakkumine.</p>
                <a href={brand.siteUrl} style={{ backgroundColor: '#88f', borderRadius: 4, padding: 8, paddingInline: 16, color: '#fff' }}>Avalehele</a>
            </div>

        );
        default: return null;
    }
}

export default AcceptResponse;